import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import { withViewportWidth } from 'decorators';
import { Card } from 'components/legacy/Card';
import AveragePricesHeader from './AveragePricesHeader';
import AveragePricesGraph from './AveragePricesGraph';

import './AveragePricesContent.scss';
import { Helmet } from 'react-helmet';

export const enhance = withViewportWidth;

export function AveragePricesContent({ city, data, viewportWidth }) {
	const priceHistory = get(data, 'priceHistory', []);
	const avgPrice = get(data, 'averagePrice', '');
	const priceDifference =
		avgPrice - get(priceHistory, `[${priceHistory.length - 1}].price`, 0);

	return (
		<>
			<Helmet>
				<script type="application/ld+json">
					{`
							{ 
							"@context": "https://schema.org", 
							"@type": "AggregateOffer", 
							"name": "Average Price of Storage Units", 
							"offers": { 
								"@type": "Offer", 
								"priceCurrency": "USD", 
								"price": ${avgPrice},  
								"seller": { 
								"@type": "Organization", 
								"name": "SpareFoot" 
								} 
							} 
							} 
						`}
				</script>
			</Helmet>

			<Card className="average-prices-content">
				<AveragePricesHeader
					city={city}
					totalReservations={get(data, 'totalReservations', 0)}
					avgPrice={avgPrice}
					priceDifference={priceDifference}
					historyLength={priceHistory.length}
				/>
				<AveragePricesGraph
					priceHistory={priceHistory}
					avgPrice={avgPrice}
					viewportWidth={viewportWidth}
				/>
			</Card>
		</>
	);
}

AveragePricesContent.propTypes = {
	city: PropTypes.string.isRequired,
	data: PropTypes.shape({
		averageMonthlyUnitPrice: PropTypes.shape({
			average_price: PropTypes.string,
			price_history: PropTypes.arrayOf(
				PropTypes.shape({
					date: PropTypes.string,
					price: PropTypes.number,
				}),
			),
		}),
	}).isRequired,
	viewportWidth: PropTypes.number.isRequired,
};

export default enhance(AveragePricesContent);
